<template>
	<TeamingChip
		:class-name="classNames"
		@click="onClick"
	>
		<template v-slot:text>
			{{ label }}
		</template>
	</TeamingChip>
</template>

<script>
import { ConfidenceLevel } from "@teaming/common-enums";
import TeamingChip from "./TeamingChip";

export default {
	name: "ConfidenceChip",

	emits: [ "click", ],

	components: {
		TeamingChip,
	},

	props: {
		className: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		classes() {
			return {
				"confidence-chip": true,
				"confidence-chip--disabled": this.disabled,
				"confidence-chip--high": this.level === ConfidenceLevel.HIGH,
				"confidence-chip--medium": this.level === ConfidenceLevel.MEDIUM,
				"confidence-chip--low": this.level === ConfidenceLevel.LOW,
				[ this.className ]: !!this.className,
			};
		},
		classNames() {
			return Object.keys( this.classes )
				.filter( className => !!this.classes[ className ] )
				.join( " " );
		},
		label() {
			return this.$t( `common.ConfidenceChip_${ this.level }Label` );
		},
	},

	methods: {
		onClick( e ) {
			e.preventDefault();
			e.stopPropagation();
			if ( this.disabled ) {
				return;
			}
			this.$emit( "click", e );
		},
	},
};
</script>

<style lang="scss" scoped>
.confidence-chip {
	&.teaming-chip {
		text-transform: uppercase;
		text-align: center;
		justify-content: center;
		border-radius: 1.5rem;
		cursor: pointer;
	}
}

.confidence-chip--disabled {
	&.teaming-chip {
		cursor: default;
	}
}

.confidence-chip--high {
	&.teaming-chip {
		background-color: $confidence-chip-background-color--high;
		color: $confidence-chip-font-color--high;
	}
}

.confidence-chip--medium {
	&.teaming-chip {
		background-color: $confidence-chip-background-color--medium;
		color: $confidence-chip-font-color--medium;
	}
}

.confidence-chip--low {
	&.teaming-chip {
		background-color: $confidence-chip-background-color--low;
		color: $confidence-chip-font-color--low;
	}
}
</style>
